<nav aria-label="breadcrumb" class="breadcrumb">
    <div class="container">
        <ul>
            <li class="breadcrumb-item" style="cursor:pointer;"><a routerLink="/home-one"><b style="color:white;">Home/</b></a></li>
            <li class="breadcrumb-item bread_active" aria-current="page"><b class="enimy" style="color:white;">About Us</b></li>
            <div>About Us </div>

        </ul>
    </div>
</nav>
<div id="about" class="about-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>About <span>SubhaSankalpam</span></h2>
            <p>Where did it all start ? Here's the beginning of our story</p>
        </div>
        <div class="row">
            <p>
                <strong>
                    In the year 2017, a profound encounter left an indelible mark on one of the founders as they embarked on
                    a work-related journey.
                </strong>
            </p>
            <p>What started as a response to a singular, heartfelt plea has since evolved into a collective effort to address a systemic challenge. The commitment to serving homemade food remains at the core of their mission, but the realization that the problem is more complex than initially perceived has fueled a determination to advocate for change, raise awareness, and implement sustainable solutions. </p>

            <div class="col-lg-7 col-md-12">
                <div class="about-content">
                    <div class="section-title">
                        <br />
                        <!--<h2>We Are Digital <span>Marketing & Branding</span></h2>-->
                        <p>
                            <strong>
                                Through their ongoing efforts, this dedicated group aims to make a lasting impact on the lives of
                                those affected by hunger, one homemade meal at a time.
                            </strong>
                        </p>
                        <p>
                            A chance meeting with an elderly lady, worn and weary, revealed a poignant
                            truth – she had gone without food for several days. Moved by compassion, especially given the late hour,
                            the founder took immediate action. Despite the lack of nearby restaurants, he procured some bread and
                            packaged food to offer her sustenance.
                        </p>
                        <p>However, the response from the elderly lady resonated deeply: "Would you mind serving some homemade food, son?" It was a plea that stirred a sense of empathy and awakened an awareness of the gap in addressing the basic needs of those struggling in the community.</p>
                        <p></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-md-12">
                <div class="about-video img_1" style="">
                    <img src="../../../../assets/img/about/aboutimg.jpg" alt="about" style="border-radius: 5px;" />
                    <!--<img src="assets/img/about.jpg" alt="about">-->
                    <div class="video-btn">
                        <!-- <button class="popup-youtube" (click)="ngxSmartModalService.getModal('popupOne').open()"><i class="fas fa-play"></i></button> -->
                    </div>
                </div>
            </div>
            <p>As this compassionate initiative unfolded, it became increasingly evident that the scope of the problem extended far beyond the initial encounter. The stark reality of widespread hunger and food insecurity began to unfold, challenging preconceived notions and underscoring the urgency of the mission. Motivated by a desire to make a meaningful impact, the group delved into understanding the scale of the issue, relying on statistics such as those from the Global Hunger Index (GHI) to illuminate the gravity of the situation.</p>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="card">
                    <div class="ico">
                        <i class="fa fa-bullseye"></i>
                    </div>
                    <h3 class="title">Mission</h3>
                    <p>
                        At SubhaSankalpam Foundation, our primary mission is to address the pressing issue of hunger.
                        We passionately work towards providing fresh and nutritious meals to those who need it the most.
                        Through our unwavering commitment, we aim to raise awareness, inspire action, and empower
                        individuals to create a meaningful difference in their communities.
                    </p>
                </div></div>
                <div class="col-lg-6">
                    <div class="card">
                        <div class="ico">
                            <i class="fa fa-eye"></i>
                        </div>
                        <h3 class="title">Vision</h3>
                        <p>
                            Our mission is clear: To ensure that no one goes to bed HUNGRY. We believe that access to
                            fresh and healthy food is a basic human right that everyone deserves. Through our collective
                            efforts, we strive to alleviate hunger and its associated challenges, such as malnutrition
                            and food insecurity.
                        </p>
                    </div>
                </div>
            </div>
    </div>
   
   
</div>
<div class="video-popup">
    <!-- <ngx-smart-modal #popupOne [identifier]="'popupOne'">
        <iframe src="https://www.youtube.com/embed/WQ119jAN4Xo" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </ngx-smart-modal> -->
</div>
<style>
    @media only screen and (max-width:600px){
        .card {
            display: inline-block;
            margin: 50px 8px;
            text-align: center;
            background-color: #FFFFFF;
            padding: 30px 20px 40px;
            border-radius: 5px;
            box-shadow: 0 1px 3px rgba(45, 62, 80, 0.3);
            height: 485px;
        }
    }
</style>
